var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({class:_vm.iconInfoClass},'div',_vm.containerProps,false),[_c('common-icon',{attrs:{"name":_vm.icon,"size":_vm.size}}),_c('div',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }